"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

// Sits at the top of every page. Polls /api/auth/me once; when the session is an
// impersonation it shows a sticky banner with a one-click "Stop" that restores
// the operator's own session. Renders nothing in the common (non-impersonated) case.
export function ImpersonationBanner() {
  const [info, setInfo] = useState<{ email: string; actor: string } | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    fetch("/api/auth/me", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d?.impersonating && d.actor) setInfo({ email: d.email, actor: d.actor });
      })
      .catch(() => {});
  }, []);

  if (!info) return null;

  async function stop() {
    setBusy(true);
    await fetch("/api/admin/impersonate", { method: "DELETE" }).catch(() => {});
    window.location.href = "/";
  }

  return (
    <>
      {/* Spacer keeps page content clear of the fixed bar. */}
      <div className="h-9 shrink-0" aria-hidden />
      <div className="fixed inset-x-0 top-0 z-[100] flex h-9 items-center justify-center gap-3 bg-amber-400 px-4 text-xs font-medium text-black">
        <span>
          Viewing as <strong>{info.email}</strong>
          <span className="hidden sm:inline"> · impersonated by {info.actor}</span>
        </span>
        <Button
          size="xs"
          variant="outline"
          disabled={busy}
          onClick={stop}
          className="h-6 border-black/30 bg-white/30 text-black hover:bg-white/60"
        >
          {busy ? "Stopping…" : "Stop impersonating"}
        </Button>
      </div>
    </>
  );
}
